import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { CONSTANTS } from "src/constants";
import { URL_CONSTANTS } from "src/constants/url.constants";
import { locales } from "src/locales/indexLocales";
import { ForgotPasswordData, ForgotPasswordProps } from "src/models/user.model";
import API_SERVICES from "src/services";
import handleResponse from "src/services/apiConfig/api.response.service";
import commonUtils from "src/utils/common.utils";

export const usePassword = () => {
  const forgotPasswordMethods = useForm<ForgotPasswordData>();
  const resetPasswordMethods = useForm<ForgotPasswordProps>();
  const [loading, setLoading] = useState<boolean>(
    CONSTANTS.COMMON_CONSTANTS.NO
  );
  const [captchaVerified, setCaptchaVerified] = useState(
    CONSTANTS.COMMON_CONSTANTS.NO
  );
  const [captchaError, setCaptchaError] = useState(
    CONSTANTS.COMMON_CONSTANTS.NO
  );
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get(CONSTANTS.TOKEN);
  const navigate = useNavigate();
  const userToken = Boolean(token);
  useEffect(() => {
    if (token) {
      localStorage.clear();
      getValidToken();
    }
  }, [token]);
  const getValidToken = async () => {
    const res = await API_SERVICES.USER.VALID_TOKEN(token);
    handleResponse(res);
  };

  const handleCaptchaChange = (token: string | null) => {
    if (token) {
      setCaptchaVerified(CONSTANTS.COMMON_CONSTANTS.YES);
      setCaptchaError(CONSTANTS.COMMON_CONSTANTS.NO);
    } else {
      setCaptchaVerified(CONSTANTS.COMMON_CONSTANTS.NO);
    }
  };

  const onSubmit = async (data: ForgotPasswordData) => {
    setLoading(CONSTANTS.COMMON_CONSTANTS.YES);
    if (!captchaVerified) {
      setCaptchaError(CONSTANTS.COMMON_CONSTANTS.YES);
      return;
    }
    const res = await API_SERVICES.USER.RESET_EMAIL({
      email: data.username?.trim(),
    });
    const response = handleResponse(res);
    if (response.ok) {
      commonUtils.toastService(
        locales.resetMessage,
        CONSTANTS.TOAST_TYPE.SUCCESS
      );
    }
    setLoading(CONSTANTS.COMMON_CONSTANTS.STOP_LOADER);
  };
  const passwordSubmit = async (data: ForgotPasswordProps) => {
    setLoading(CONSTANTS.COMMON_CONSTANTS.YES);
    const res = await API_SERVICES.USER.RESET_PASSWORD({
      password: data.password,
      token: token,
    });
    const response = handleResponse(res);
    if (response.ok) {
      commonUtils.toastService(
        locales.passwordUpdateMessage,
        CONSTANTS.TOAST_TYPE.SUCCESS
      );
      navigate(URL_CONSTANTS.LOGIN);
    }
    setLoading(CONSTANTS.COMMON_CONSTANTS.NO);
  };

  return {
    userToken,
    loading,
    forgotPasswordMethods,
    resetPasswordMethods,
    onSubmit,
    passwordSubmit,
    captchaError,
    captchaVerified,
    handleCaptchaChange,
  };
};
